/**
 * Teams data utils – all mapping/derivation from raw API lives here.
 * Thunk and slice stay clear (raw response only).
 * API shape: { success, data: { data: [teams], meta } }
 */

/** Derive list for UI: maps name → teamName */
export function getTeamsListFromApiData(data) {
  const rawList = data?.data?.data ?? [];
  return rawList.map((t) => ({
    ...t,
    teamName: t.name ?? t.teamName,
  }));
}

/** Get meta from raw API response (pagination etc.) */
export function getTeamsMetaFromApiData(data) {
  return data?.data?.meta ?? null;
}

/** Map UI status to API enum (Active → ACTIVE, Inactive / legacy In-Active → INACTIVE) */
export function toTeamStatusApi(value) {
  if (!value) return "ACTIVE";
  const map = {
    Active: "ACTIVE",
    "In-Active": "INACTIVE",
    Inactive: "INACTIVE",
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE",
  };
  return map[value] || value.toUpperCase().replace(/\s+/g, "_");
}

/** Form/UI payload → API update payload (name, status: ACTIVE | INACTIVE) */
export function formToTeamUpdatePayload(formData) {
  return {
    name: (formData.teamName ?? formData.name ?? "").trim(),
    status: toTeamStatusApi(formData.status),
  };
}
